<template>
  <div class="d-flex gap-2 align-items-center announcement-banner">
    <span class="material-symbols-outlined">campaign</span>
    <span
      class="flex-grow-1 text-content"
      ref="text-content"
    >
      <strong class="me-2">{{ announcement.title }}</strong>
      <span>{{ announcement.content }}</span>
    </span>
    <button
      v-if="hasLongMessage"
      class="show-more-button"
      @click="showMore = !showMore"
    >
      {{ showMore ? t('common_actions.less') : t('common_actions.more') }}
    </button>
    <span
      class="material-symbols-outlined close-icon"
      @click="emit('dismiss', announcement.id)"
    >
      close
    </span>
  </div>
</template>
<script lang="ts" setup>
import type { AnnouncementResponseType } from '@shared/generated';
import { computed, ref, useTemplateRef, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const emit = defineEmits(['dismiss']);
defineProps<{ announcement: AnnouncementResponseType }>();

const textContent = useTemplateRef('text-content');
const { t } = useI18n();
const hasLongMessage = ref<boolean>(false);
const showMore = ref<boolean>(false);

watch(textContent, (newTemplateRef) => {
  // If scroll height is > than client height it indicates the content is being truncated.
  hasLongMessage.value = newTemplateRef
    ? newTemplateRef.scrollHeight > newTemplateRef.clientHeight
    : false;
});

const maxLines = computed(() => {
  if (showMore.value) return 'unset';
  else return '1';
});
</script>
<style lang="scss">
$maxLines: v-bind(maxLines);

.announcement-banner {
  background-color: #fdf5cf;
  border-top: 1px solid white;
  border-bottom: 1px solid white;
  color: var(--bs-gray-500);
  width: 100%;
  padding: 1rem 1.75rem;
  .text-content {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: $maxLines;
    -webkit-box-orient: vertical;
  }
  .material-symbols-outlined {
    min-width: 22px;
  }
  .show-more-button {
    all: unset;
    font-weight: bold;
    min-width: 40px;
    text-align: center;
  }
  .show-more-button,
  .close-icon {
    color: var(--bs-primary);
  }
}
</style>
